/* eslint-disable eqeqeq */
import { map } from 'rxjs/operators';
import DealType from '../../../../../enums/deal-type';
import { Option } from '../../../../../components/form/elements/select';
import { ObservableOptions } from '../../../../../components/form/elements/select/async-select';
import Classifier from '../../../../../enums/classifier';
import { Product } from '../../../../../interfaces/product';
import { ProductService } from '../../../../../services/product.service';
import { categoryDataMap } from './async-categories';
import { typeDataMap } from './async-types';
import AnimalType from '../../../../../enums/animal-type';

function productDataMap(v: Product) {
  return {
    label: v.name,
    value: v.id,
    obtain_type_id: v.obtain_type_id,
    category: categoryDataMap(v.category),
    type: typeDataMap(v.type),
    unit: { label: v.unit, value: v.unit },
    price: v.planned_price,
  };
}

const productIsSelected = (selectedProducts, product) => {
  let notSelected = true;
  selectedProducts.forEach((element) => {
    if (element.product_id && element.product_id.value === product) {
      notSelected = false;
    }
  });
  return notSelected;
};

export default function asyncProducts({
  productService,
  farmId,
  classifierKeys = [
    Classifier.PRODUCT_CATEGORIES_AND_TYPES,
    Classifier.OBTAINED_PRODUCT_CATEGORIES_AND_TYPES,
  ],
  isMedicament = false,
  eventType,
}: {
  productService: ProductService;
  farmId: string;
  classifierKeys?: Classifier[];
  isMedicament?: boolean;
  eventType?: string;
}): ObservableOptions {
  return (
    value: string,
    loadedOptions: Option[],
    { parentName, page, getValues }: any
  ) => {
    const dealType = getValues('type')?.value;

    const showClassifiers =
      dealType == DealType.purchased || dealType == DealType.produced;

    if (!showClassifiers) {
      classifierKeys = classifierKeys.filter(
        (key) => key !== Classifier.OBTAINED_PRODUCT_CATEGORIES_AND_TYPES
      );
    }

    const params: any = { page };

    const productCategoryId = getValues(
      parentName
        ? parentName.concat('.product_category_id')
        : 'product_category_id'
    )?.value;

    const productTypeId = getValues(
      parentName ? parentName.concat('.product_type_id') : 'product_type_id'
    )?.value;

    if (productCategoryId) {
      params.product_categories = productCategoryId;
    }

    if (productTypeId) {
      params.product_types = productTypeId;
    }

    const products = getValues('products');

    return productService.index(farmId, { ...params, value }).pipe(
      map((response) => {
        const afterMedicamentCheckData = isMedicament
          ? response.data.filter(
              (product) => product.category_id === params.product_categories
            )
          : response.data;
        const mappedData = afterMedicamentCheckData.map(productDataMap);
        const afterEventTypeCheckData = eventType === AnimalType.starter_feed
          ? mappedData.filter((v) => Number.isInteger(v.type.dry_matter))
          : mappedData;
        return {
          hasMore: response.last_page > response.current_page,
          options: afterEventTypeCheckData.filter((value) => {
            return productIsSelected(products, value.value);
          }),
          additional: { page: response.current_page + 1 },
        };
      })
    );
  };
}
